import axios from 'axios'
import AscentiaService from './ascentiaService'
import { CUSTOM_ALERT_CONSTS as CAC } from '../stores/consts'
const values = {
  customAlerts: null,
  customAlert: null,
  parameterList: null,
  sharedAnalyticsForAirline: null,
}
let dataBricksGetStatusCall = null
const getters = {
  customAlerts() {
    return axios.get('/customalert')
  },
  customAlert(alertId) {
    return axios.get(`/customalert/${alertId}`)
  },
  customAlertTypes() {
    return axios.get('/CustomAlert/CustomAlertTypes')
  },
  customAlertAdvancedFunctions(alertTypeId) {
    return axios.get(
      `/customalert/AdvancedCustomAlertsFunctions?customAlertTypeId=${alertTypeId}`,
    )
  },
  sharedAnalyticsForAirline(airlineIds) {
    let url = ``
    const airlineIdParams = new URLSearchParams()
    if (airlineIds) {
      airlineIds.forEach(value => {
        airlineIdParams.append('airlineIds', value)
      })
    }
    url = `/CustomAlert/Shared?${airlineIdParams}`
    return axios.get(url)
  },
  fullFlightParameterList(fullFlightInfo) {
    const airlineIdParams = new URLSearchParams()
    let url = ``
    if (fullFlightInfo.airlineIds) {
      fullFlightInfo.airlineIds.forEach(value => {
        airlineIdParams.append('airlineIds', value.airlineId)
      })
    }
    if (fullFlightInfo.platformId) {
      url = `/DataElement/mapping?${airlineIdParams}&masterModelId=${fullFlightInfo.platformId}`
    } else {
      url = `/DataElement/mapping?${airlineIdParams}`
    }
    return axios.get(url)
  },
  masterModelByParameter(parameterInfo) {
    return axios.get(
      `/DataElement/${parameterInfo.parameterId}?airlineIds=${parameterInfo.airlineId}`,
    )
  },
  snapshotMasterModelByParameter(parameterInfo) {
    const url = `/Acmf/Parameter/${parameterInfo.parameterId}?airlineIds=${parameterInfo.airlineId}`
    return axios.get(url)
  },
  snapshotParameterList(data) {
    let url
    if (typeof data.airlineId === 'number') {
      url = `/CustomAlert/Parameters/ACMF?isComparable=true&reportNumberId=${data.reportType}&airlineId=${data.airlineId}`
    } else {
      url = `/CustomAlert/Parameters/ACMF/Icao?isComparable=true&reportNumberId=${data.reportType}&icaoCode=${data.airlineId}`
    }
    if (data.parameterId) {
      url = `${url}&acmfDataElementId=${data.parameterId}`
    }
    return axios.get(url)
  },
  snapshotTailList(parameterInfo) {
    let url
    if (typeof parameterInfo.airlineId === 'number') {
      url = `/Acmf/Parameter/${parameterInfo.parameterId}?airlineids=${parameterInfo.airlineId}`
    } else {
      url = `/Acmf/Parameter/icao/${parameterInfo.parameterId}?icaoCodes=${parameterInfo.airlineId}`
    }
    return axios.get(url)
  },
  fullFlightTailList(alertInfo) {
    const url = `/DataElement/${alertInfo.parameterId}?airlineId=${alertInfo.airlineId}`
    return axios.get(url)
  },
  advancedSnapshotTailList(alertInfo) {
    const url = `/Acmf/aircraft?reportNumberId=${alertInfo.acmfReportNumberId}&airlineId=${alertInfo.airlineId}`
    return axios.get(url)
  },
  advancedFullFlightTailList(alertInfo) {
    const url = `/Lookups/tailsbyairline?airlineId=${alertInfo.airlineId}`
    return axios.get(url)
  },
  acmfHistogramData(alertInfo) {
    let url
    if (typeof alertInfo.airlineId === 'number') {
      url = `/Acmf/HistogramSnapshot?DataElementId=${alertInfo.parameterId}&airlineIds=${alertInfo.airlineId}&AcmfReportNumberId=${alertInfo.reportId}`
    } else {
      url = `/Acmf/HistogramSnapshot?DataElementId=${alertInfo.parameterId}&icaoCodes=${alertInfo.airlineId}&AcmfReportNumberId=${alertInfo.reportId}`
    }
    return axios.get(url)
  },
  cplHistogramData(alertInfo) {
    let flightPhaseParams = ''
    alertInfo.flightPhase.forEach(value => {
      flightPhaseParams = `${flightPhaseParams}&flightPhases=${value}`
    })
    const url = `/CustomAlert/Histogram?DataElementId=${alertInfo.parameterId}&maxFlights=${alertInfo.maxFlights}${flightPhaseParams}&ICAOcodes=${alertInfo.airlineICAOCode}`
    return axios.get(url)
  },
  customAlertLogicValidation(logic) {
    const encodedString = btoa(logic.logicString)
    const url = `/CustomAlert/LogicValidation`
    return axios.get(url, {
      params: {
        logicString: encodedString,
        alertTypeId: logic.alertTypeId,
      },
    })
  },
  partNumbers(param) {
    const url = `/CustomAlert/PartNumbers?masterModelId=${param.platformId}&airlineId=${param.airlineId}`
    return axios.get(url)
  },
  customAlertPerformance(id) {
    const url = `/CustomAlert/Performance/${id}`
    return axios.get(url)
  },
  getDataBricksRunIdStatus(runId) {
    dataBricksGetStatusCall = axios.CancelToken.source()
    const url = `/CustomAlert/GetRunningStatusByRunId?runId=${runId}`
    return axios.get(url, {
      cancelToken: dataBricksGetStatusCall.token,
    })
  },
  getLookbackRunCount(airlineId) {
    const url = `/CustomAlert/LookbackRunCount?airlineId=${airlineId}`
    return axios.get(url)
  },
}
const saves = {
  customAlert(customAlert) {
    if (typeof customAlert.airlineId === 'string') {
      customAlert.icaoCode = customAlert.airlineId
      customAlert.airlineId = null
    }
    if (customAlert.id !== null) {
      return axios.put(`/customalert/${customAlert.id}`, customAlert)
    } else {
      return axios.post(`/customalert`, customAlert)
    }
  },
  dataBricksStatus(lookback) {
    dataBricksGetStatusCall = axios.CancelToken.source()
    const url = `/CustomAlert/TriggerLookbackCalculation`
    return axios.post(url, lookback, {
      cancelToken: dataBricksGetStatusCall.token,
    })
  },
  cancelDataBrick(jobRunId) {
    if (dataBricksGetStatusCall) {
      dataBricksGetStatusCall.cancel(CAC.CANCEL_RUNNING_GETSTATUS_LOOKBACK_API)
    }
    const url = `/CustomAlert/CancelLookBackCalculation?runId=${jobRunId}`
    return axios.post(url)
  },
}
const deletes = {
  customAlert(alertId) {
    return axios.delete(`/customalert/${alertId}`)
  },
}
export default class CustomAlertService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
